/**
 * Print the passed value in console before returning it.
 *
 * Example:
 * ```ts
 * // if you have a function call you want to inspect...
 * someFn(someParam, someOtherParam);
 * // ...you can simply wrap the args in with dbg like so:
 * someFn(dbg(someParam), someOtherParam);
 * ```
 */
export function dbg<T>(v: T): T {
  console.log(v);
  return v;
}
